import { MailOutlined, PhoneOutlined } from "@ant-design/icons";
import { Button, Card, Checkbox, Col, Form, List, Row, Select } from "antd";
import { Formik } from "formik";
import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useTheme } from "styled-components";
import * as Yup from "yup";
import BCInput from "../../components/BCInput";
import { phoneMaskBR } from "../../utils/mask";
import { getPermissions } from "./service";
const { Option } = Select;
const { Meta } = Card;

function UsersCreateAdmin() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [permissions, setPermissions] = useState([]);

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email(t("Invalid_Email"))
      .required(t("Email_is_required")),
    phone: Yup.string().required(t("Phone_Is_Required")),
    phoneCode: Yup.string().required(t("Phone_Is_Required")),
    name: Yup.string().required(t("Name_is_Required")),
    permissions: Yup.array()
      .required(t("Permissions_is_Required"))
      .min(1, t("Permissions_is_Required")),
    state: Yup.string(),
    city: Yup.string(),
  });
  const findPermissions = useCallback(async () => {
    const result = await getPermissions();
    console.log("AQUQ", result);
    setPermissions(result);
  }, []);

  useEffect(() => {
    findPermissions();
  }, [findPermissions]);

  async function createUser(values) {
    // await createAdmin(
    //   values.name,
    //   values.email,
    //   `${values.phoneCode} ${values.phone}`,
    //   values.organizationId,
    //   values.permissions
    // );
    navigate("/users/admins");
  }

  return (
    <div>
      <Formik
        initialValues={{
          email: "",
          name: "",
          phone: "",
          organizationId: "",
          permissions: [],
          phoneCode: "+55",
        }}
        validationSchema={validationSchema}
        onSubmit={createUser}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          errors,
          touched,
        }) => (
          <Form layout="vertical" onFinish={handleSubmit}>
            <Row style={{ width: "100%", height: "100vh" }}>
              <Col xs={24} sm={6}>
                <Row gutter={16}>
                  <Col xs={24} sm={24}>
                    <Card
                      style={{
                        height: "750px",
                        borderRadius: 0,
                        backgroundColor: "#d3d3d3",
                      }}
                    >
                      <span
                        style={{
                          color: theme.titles,
                          fontSize: "18px",
                          marginBottom: "10px",
                        }}
                      >
                        {t("USERS_11")}
                      </span>
                      <Row gutter={16}>
                        <Col xs={24} sm={24}>
                          <Form.Item
                            help={
                              touched.name && errors.name ? errors.name : ""
                            }
                            validateStatus={
                              touched.name && errors.name ? "error" : ""
                            }
                          >
                            <BCInput
                              name="name"
                              className="input"
                              value={values.name}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              placeholder={t("Name")}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col xs={24} sm={24}>
                          <Form.Item
                            help={
                              touched.email && errors.email ? errors.email : ""
                            }
                            validateStatus={
                              touched.email && errors.email ? "error" : ""
                            }
                          >
                            <BCInput
                              prefix={<MailOutlined />}
                              name="email"
                              className="input"
                              value={values.email}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              placeholder={t("Email")}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col xs={24} sm={24}>
                          <Form.Item
                            help={
                              touched.phone && errors.phone ? errors.phone : ""
                            }
                            validateStatus={
                              touched.phone && errors.phone ? "error" : ""
                            }
                          >
                            <BCInput
                              name="phone"
                              className="input"
                              value={values.phone}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              placeholder={t("Phone")}
                              onKeyUp={(event) => phoneMaskBR(event)}
                              prefix={<PhoneOutlined />}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={16}>
                        <Button
                          style={{
                            backgroundImage: theme.button_confirm,
                            color: theme.text_button,
                          }}
                          data-cy="bc-submit"
                          htmlType="submit"
                          block
                        >
                          Entrar
                        </Button>
                      </Row>
                    </Card>
                  </Col>
                </Row>
              </Col>
              <Col xs={24} sm={6}>
                <Card
                  style={{ height: "750px", width: "100vh", borderRadius: 0 }}
                >
                  <span
                    style={{
                      color: theme.titles,
                      fontSize: "18px",
                      marginBottom: "10px",
                    }}
                  >
                    {t("USERS_12")}
                  </span>
                  <Form.Item
                    help={
                      touched.permissions && errors.permissions
                        ? errors.permissions
                        : ""
                    }
                    validateStatus={
                      touched.permissions && errors.permissions ? "error" : ""
                    }
                  >
                    <Checkbox.Group
                      name="permissions"
                      value={values.permissions}
                      onChange={(checkedValues) =>
                        handleChange({
                          target: {
                            name: "permissions",
                            value: checkedValues,
                          },
                        })
                      }
                    >
                      <List
                        dataSource={permissions}
                        renderItem={(permission) => (
                          <List.Item>
                            <Checkbox
                              value={permission._id}
                              style={{
                                "--checkbox-border-color":
                                  values.permissions.includes(permission._id)
                                    ? "green"
                                    : "",
                              }}
                            >
                              {permission.description_pt}
                            </Checkbox>
                          </List.Item>
                        )}
                      />
                    </Checkbox.Group>
                  </Form.Item>
                </Card>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </div>

    // <Row style={{ width: "100%", height: "100vh" }}>
    //   <Col span={8}>
    //     <Card style={{ height: "100%", borderRadius: 0 }}>

    //     </Card>
    //   </Col>
    //   <Col span={16}>
    //     <Card style={{ height: "100%", borderRadius: 0 }}>BBB</Card>
    //   </Col>
    // </Row>
  );
}

export default UsersCreateAdmin;
